var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isUndefined = (val) => val === void 0;
const isDefined = (val) => !isUndefined(val);
const validate = ({ targetBlank, nofollow, target, rel }) => isUndefined(targetBlank) && isUndefined(nofollow) && isDefined(target) && isDefined(rel);
const linkDataNormalizer = (componentData, { anchorTarget, relValue }) => {
  const _a = componentData, { targetBlank, nofollow } = _a, rest = __objRest(_a, ["targetBlank", "nofollow"]);
  if (validate(componentData)) {
    return componentData;
  }
  return __spreadValues({
    target: targetBlank ? "_blank" : anchorTarget,
    rel: nofollow ? "nofollow" : relValue
  }, rest);
};

export { linkDataNormalizer as default };
//# sourceMappingURL=linkDataNormalizer.js.map
